import { useEffect } from "react";

import { useFetchedSelectionsRequestsHook } from "./useFetchedSelectionsRequestsHook";

/**
 * Lazy reference-data loaders.
 *
 * `users` (the app-wide B2B user list) and `correspondents` are shared Redux
 * slices that many screens read but only SOME need. Rather than fetching both
 * eagerly for every page in AuthenticatedDashboard, a screen calls the matching
 * hook below to pull what it actually consumes. The underlying `ensure*` helpers
 * are cache-gated (skip the network when the slice is already populated) and
 * de-duped (concurrent mounts share one in-flight request), so calling these
 * from several mounted components is cheap and safe.
 *
 * Empty deps on purpose: the `ensure*` functions aren't memoized, and the
 * internal Redux-presence gate already makes a re-run a no-op — so we run once
 * on mount and intentionally omit them from deps to avoid a refetch loop.
 */
export const useEnsureUsers = () => {
  const { ensureAllUsers } = useFetchedSelectionsRequestsHook();
  useEffect(() => {
    ensureAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const useEnsureCorrespondents = () => {
  const { ensureCorrespondents } = useFetchedSelectionsRequestsHook();
  useEffect(() => {
    ensureCorrespondents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
